import { DocumentNode, gql } from '@apollo/client/core';
import { ITagContextMatchesParams } from '../utils';

export const GET_CHECKOUT_SUGGESTIONS: DocumentNode = gql`
  query GetCheckoutSuggestions(
    $tags: Tags
    $isAuthenticated: Boolean!
    $orders: Int
    $isWebMobile: Boolean!
    $isAppNative: Boolean!
    $previewUrl: String
  ) {
    getCheckoutSuggestionsPage(
      tags: $tags
      isAuthenticated: $isAuthenticated
      orders: $orders
      isWebMobile: $isWebMobile
      isAppNative: $isAppNative
      previewUrl: $previewUrl
    ) {
      uid
      condition
      feature_flag_key
      header_title
      ab_test_header_title
      group {
        uid
        slice_type
        items
        primary
      }
      ab_test_group {
        uid
        slice_type
        items
        primary
      }
    }
  }
`;

export type GetCheckoutSuggestionsQueryResult = {
  getCheckoutSuggestionsPage: {
    uid: string;
    condition: string | null;
    feature_flag_key: string | null;
    header_title: string | null;
    ab_test_header_title: string | null;
    group: [];
    ab_test_group: [];
  };
};

export type GetCheckoutSuggestionsQueryVariables = Omit<
  ITagContextMatchesParams,
  'isMember'
> & {
  previewUrl?: string;
};
